import React, { Component } from 'react';
import Config from '../Config';
import Validate from '../components/Validate'

class EditContactPerson extends Component {
    constructor(props) {
        super(props);

        // check if customer was previously edited
        var cp = this.props.cp;
        if (this.props.changes.state.changedContactPersons) {
            cp = this.props.changes.state.changedContactPersons.find(p => p.id === this.props.cp.id) ?? cp;
        }

        this.state = {
            id: cp.id,
            nameId: cp.nameId,
            internalCode: cp.internalCode,
            firstName: cp.name.firstName ?? "",
            prefix: cp.name.prefix ?? "",
            lastName: cp.name.lastName ?? "",
            zipCode: cp.address.zipCode ?? "",
            streetNumber: cp.address.streetNumber ?? "",
            building: cp.address.building ?? "",
            phone1: cp.contact.phone1 ?? "",
            phone2: cp.contact.phone2 ?? "",
            mobile: cp.contact.mobile ?? "",
            email: cp.contact.email ?? ""
        };

        this.cp = cp;

    }

    componentDidMount() {
        this.getAddress(this.cp.address.zipCode);
    }

    close() {
        this.props.close();
    }

    doDelete() {
        this.setState({ mode: "confirmDelete" });
    }

    removeConfirmed() {
        this.props.changes.RemoveContactPerson(this.state.internalCode);
        this.props.close();
    }

    hasChanges() {
        // check if there are changes to the contactperson
        var org=this.props.cp;
        if (this.state.firstName!==(org.name.firstName?? "") ||
            this.state.prefix!==(org.name.prefix?? "") ||
            this.state.lastName!==(org.name.lastName?? "") ||
            this.state.zipCode!==(org.address.zipCode?? "") ||
            this.state.streetNumber!==(org.address.streetNumber?? "") ||
            this.state.building!==(org.address.building?? "") ||
            this.state.phone1!==(org.contact.phone1?? "") ||
            this.state.phone2!==(org.contact.phone2?? "") ||
            this.state.mobile!==(org.contact.mobile?? "") ||
            this.state.email!==(org.contact.email?? "")) return true;
        return false;

    }

    save() {
        // only save when there are actual changes
        if (this.hasChanges()) {
            this.props.changes.SetContactPerson({
                id: this.state.id,
                internalCode: this.state.internalCode,
                relationCode: this.props.cp.relationCode,      // note : this remains unaltered
                relationName: this.props.cp.relationName,      // note : this remains unaltered
                name: {
                    firstName: this.state.firstName ?? "",
                    prefix: this.state.prefix ?? "",
                    lastName: this.state.lastName
                },
                address: {
                    zipCode: this.state.zipCode ?? "",
                    streetNumber: this.state.streetNumber ?? "",
                    street: this.state.street ?? this.props.cp.address.street,
                    city: this.state.city ?? this.props.cp.address.city,
                    building: this.state.building ?? ""
                },
                contact: {
                    mobile: this.state.mobile ?? "",
                    phone1: this.state.phone1 ?? "",
                    phone2: this.state.phone2 ?? "",
                    email: this.state.email ?? ""
                },
                active: true
            });
        }
        this.props.close();
    }
    changeZipCode(evt) {
        this.setState({ zipCode: evt.target.value });
        if (!evt.target.value || evt.target.value.length < 6 || evt.target.value.length > 7) return;
        this.getAddress(evt.target.value);
    }

    getAddress(code) {
        var url = Config.DigibonServiceBase + `zipCode/${code}`;
        var options = Config.GetBearer();

        fetch(url, options)
            .then((res) => { return res.ok ? res.json() : { status: res.status } })
            .then((json) => {
                if (json) this.setState({ street: json.street, city: json.city });
            });
    }

    render() {
        console.log();
        return <div>
            <h3>Wijzig contactpersoon gegevens</h3>

            <div className="row">

                <div className="col">Voornaam<br />
                    <input className="form-control" value={this.state.firstName} onChange={p => this.setState({ firstName: p.target.value })} ></input>
                </div>
                <div className="col">Tussenvoegsel
                    <br />
                    <input className="form-control" value={this.state.prefix} onChange={p => this.setState({ prefix: p.target.value })} ></input></div>
                <div className="col-6">Achternaam
                    <br />
                    <input className="form-control" value={this.state.lastName} onChange={p => this.setState({ lastName: p.target.value })} ></input></div>

            </div>

            <div className="row mt-4">
                <div className="col">
                    <div className="row">
                        <div className="col">Postcode<br />
                            <input className="form-control" value={this.state.zipCode} maxLength="7" onChange={this.changeZipCode.bind(this)} ></input></div>
                        <div className="col">Huisnummer<br />
                            <input className="form-control" value={this.state.streetNumber} maxLength="10" onChange={p => this.setState({ streetNumber: p.target.value })} ></input></div>
                        <div className="col">Toevoeging<br />
                            <input className="form-control" value={this.state.building} onChange={p => this.setState({ building: p.target.value })} ></input></div>
                    </div>

                    {this.state.street && <div className="mt-2 mb-2">
                        <div><b>Adres:</b></div>
                        <div>{this.state.street} {this.state.streetNumber} {this.state.building}</div>
                        <div>{this.state.zipCode} {this.state.city}</div>
                    </div>}

                </div>
                <div className="col">
                    <div>Telefoon nummer 1<br />
                        <input className="form-control" value={this.state.phone1} maxLength="10" onChange={p => this.setState({ phone1: p.target.value })} ></input>
                        <Validate value={this.state.phone1} type="phone"></Validate>
                    </div>
                    <div >Telefoon nummer 2<br />
                        <input className="form-control" value={this.state.phone2} maxLength="10" onChange={p => this.setState({ phone2: p.target.value })} ></input>
                        <Validate value={this.state.phone2} type="phone"></Validate>
                    </div>
                    <div >Telefoon nummer 3<br />
                        <input className="form-control" value={this.state.mobile} maxLength="10" onChange={p => this.setState({ mobile: p.target.value })} ></input>
                        <Validate value={this.state.mobile} type="phone"></Validate>
                    </div>
                    <div >Email<br />
                        <input className="form-control" value={this.state.email} onChange={p => this.setState({ email: p.target.value })} ></input>
                        <Validate value={this.state.email} type="email"></Validate>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    {this.state.nameId === this.props.bp.contactPerson && <div>
                        <i className="fa-solid fa-circle-info"></i> Dit is de primaire contact persoon
                    </div>}
                    {this.state.nameId !== this.props.bp.contactPerson &&
                        <button className="btn btn-danger mt-4" onClick={this.doDelete.bind(this)}>
                            Verwijderen
                        </button>
                    }
                </div>
                <div className="col-auto">
                    <button className="btn btn-primary mt-4" onClick={this.save.bind(this)}>
                        Opslaan
                    </button>
                </div>
            </div>

            {this.state.mode === "confirmDelete" &&
                <div>
                    <div className="message-back"></div>

                    <div className="message-front">
                        <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={p => this.setState({ mode: "" })}>
                            <i className="fa-sharp fa-solid fa-xmark"></i>
                        </button>

                        <p>Weet je zeker dat deze contactpersoon verwijderd dient te worden ?</p>

                        <div className="row">
                            <div className="col">

                            </div>
                            <div className="col-auto">
                                <button className="btn btn-secondary me-2" onClick={p => this.setState({ mode: "" })}>&#160;&#160;&#160;&#160;&#160;&#160;&#160;nee&#160;&#160;&#160;&#160;&#160;&#160;&#160;</button>
                                <button className="btn btn-primary me-2 ms-auto" onClick={p => this.removeConfirmed()}>&#160;&#160;&#160;&#160;&#160;&#160;&#160;ja&#160;&#160;&#160;&#160;&#160;&#160;&#160;</button>
                            </div>

                        </div>




                    </div>
                </div>
            }
        </div>
    }
}

export default EditContactPerson;